import { render } from "./MainBestSellers.vue?vue&type=template&id=53d9c9a6&scoped=true"
import script from "./MainBestSellers.vue?vue&type=script&lang=js"
export * from "./MainBestSellers.vue?vue&type=script&lang=js"

import "./MainBestSellers.vue?vue&type=style&index=0&id=53d9c9a6&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d9c9a6"]])

export default __exports__